"use client";

import { cn } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/app/ui/imported/tooltip";

const TOOLTIP = "⚜️ עונה מקורית — הקלאסיקה של נייטפול";

export function OGBadge({
    className,
    size = "sm",
}: {
    className?: string;
    size?: "sm" | "md" | "lg";
}) {
    return (
        <Tooltip>
            <TooltipTrigger
                className={cn(
                    "bg-nfPurple-800/60 text-nfPurple-300 border border-nfPurple-600/40",
                    "rounded-full inline-flex items-center gap-1 select-none whitespace-nowrap",
                    "cursor-help",
                    size === "sm" && "text-[0.65em] px-1.5 py-0.5",
                    size === "md" && "text-xs px-2 py-0.5",
                    size === "lg" && "text-sm sm:text-base px-3 py-1 font-bold tracking-wide",
                    className,
                )}
            >
                ✨ OG
            </TooltipTrigger>
            <TooltipContent side="bottom">
                {TOOLTIP}
            </TooltipContent>
        </Tooltip>
    );
}
